import {generateUUID} from '../../../../utility/uuidUtil';
import {FormBuilderComponentTypes} from './ComponentList';

export const getComponentByType = (type) => {
    switch (type) {
        case 'singleText':
            return {
                type, label: 'Single Text Line', description: '', validation: {min: 1, max: 50},
            };
        case 'textBox':
            return {
                type, label: 'Textbox', description: '',
            };
        case 'multiLineInput':
            return {
                type,
                label: 'Multiple Inputs',
                description: '',
                inputs: [{id: generateUUID(), title: '' }, {id: generateUUID(), title: '' }]
            };
        case 'appointmentBooking':
            return {
                type, label: 'Appointment Booking', description: '', bookingUrl: ''
            };
        case 'payment':
            return {
                type, label: 'Payment', description: '', paymentUrl: ''
            };
        case FormBuilderComponentTypes.MedicineStock:
            return {
                // AD-2689 (Maria): starts with a question for the parent, not the component's name a second time.
                type, label: 'Please enter each box of medicine you are sending into school.', description: ''
            };
        case FormBuilderComponentTypes.MedicineDispense:
            return {
                type, label: 'Doses given', description: '', medicineLookupId: null
            };
        case FormBuilderComponentTypes.StripePayment:
            return {
                type, label: 'Stripe Payment', description: ''
            };
        case 'checkboxQuestion':
            return {
                type, label: 'Checkbox', description: '', value: false
            };
        case 'signature':
            return {
                type, label: 'Signature', description: ''
            };
        case 'additionalNotes':
            return {
                type, label: 'Notes', description: '',
            };
        case 'attachment':
            return {
                type, label: 'Attachment', description: '', attachments: [],
            };
        case 'image':
            return {
                type, label: 'Image', description: '', attachments: [],
            };
        case 'multipleChoice':
            return {
                type,
                label: 'Multiple Choice',
                description: '',
                options: [{id: generateUUID(), description: ''}, {
                    id: generateUUID(),
                    description: ''
                }, {id: generateUUID(), description: ''}],
            };
        case 'singleChoice':
            return {
                type,
                label: 'Single Choice',
                description: '',
                options: [{id: generateUUID(), description: ''}, {
                    id: generateUUID(),
                    description: ''
                }, {id: generateUUID(), description: ''}],
            };
        case 'linearScale':
            return {
                type,
                label: 'Linear Scale',
                description: '',
                startFrom: 1,
                endAt: 5,
                startLabel: '',
                endLabel: ''
            };
        case 'tickBoxGrid':
            return {
                type,
                label: 'Tick Box Grid',
                description: '',
                columns: [{id: generateUUID(), title: ''}],
                rows: [{id: generateUUID(), title: ''}],
                allowCustomRows: false
            };
        case 'multipleChoiceGrid':
            return {
                type,
                label: 'Multiple Choice Grid',
                description: '',
                columns: [{id: generateUUID(), title: ''}],
                rows: [{id: generateUUID(), title: ''}],
                allowCustomRows: false
            };
        case 'dropdown':
            return {
                type,
                label: 'Dropdown',
                description: '',
                options: [
                    {id: generateUUID(), description: ''},
                    {id: generateUUID(), description: ''},
                    {id: generateUUID(), description: ''}],
            };
        case FormBuilderComponentTypes.NumericInputBox:
            return {
                type: FormBuilderComponentTypes.NumericInputBox,
                label: 'Numeric Input',
                description: '',
            };
        case FormBuilderComponentTypes.OfferStatusChoice:
            return {
                type,
                label: 'Application Status',
                description: 'Please select one of the options below to indicate your decision on the offer:',
                options: [
                    {id: generateUUID(), description: '', value: ''},
                    {id: generateUUID(), description: '', value: ''}]
            };
        case FormBuilderComponentTypes.FileUploader:
            return {
                type, label: 'File Uploader', description: '',
            };
        case FormBuilderComponentTypes.DateTime:
            return {
                type, label: 'Date and Time', description: '',
            };
        case FormBuilderComponentTypes.Date:
            return {
                type, label: 'Date', description: '',
            };
        case FormBuilderComponentTypes.Dropdown:
            return {
                label: 'Dropdown',
                type: 'dropdown',
                // AD-2689 (Maria): starts empty, like the other questions, so the grey text shows what to type.
                description: '',
                options: [{id: generateUUID(), description: 'Option 1'}],
                enableValidation: true
            }
        case FormBuilderComponentTypes.LookupDropdown:
            return {
                label: 'Lookup Dropdown',
                type: 'lookupDropdown',
                // AD-2689 (Maria): starts empty, like the other questions, so the grey text shows what to type.
                description: '',
                lookupType: '',
                options: [],
                enableValidation: true
            }
        case FormBuilderComponentTypes.Address:
            return {
                type: FormBuilderComponentTypes.Address,
                label: 'Address',
                description: '',
                enableValidation: false
            };
        case FormBuilderComponentTypes.IntakeChoice:
            return {
                type: FormBuilderComponentTypes.IntakeChoice,
                label: 'Intake Choice',
                description: 'Please select an intake:',
                options: [
                    {id: generateUUID(), description: '', value: ''},
                    {id: generateUUID(), description: '', value: ''}],
                enableValidation: true
            };
        case FormBuilderComponentTypes.BoarderStatusChoice:
            return {
                type: FormBuilderComponentTypes.BoarderStatusChoice,
                label: 'Boarder Status',
                description: 'Select your preferred boarder status.',
                options: [
                    { id: generateUUID(), description: '', value: '' },
                    { id: generateUUID(), description: '', value: '' }
                ],
                enableValidation: true
            };
        case 'questionGrid':
            return {
                type,
                label: 'Question Grid',
                description: '',
                inputs: [
                    { id: generateUUID(), title: '', required: false },
                    { id: generateUUID(), title: '', required: false }
                ],
                allowCustomRows: false
            };
        case 'separator':
            return {
                type,
                label: 'Separator',
                description: '',
                alignment: 'center'
            };
        case FormBuilderComponentTypes.AdmissionCategories:
            // Stored as a multipleChoice so every existing path - the response export, the PDF, the
            // prefill and the placeholders - keeps working. The key is what sends the ticks to the
            // child's profile, and it is what stops a school retyping the criteria on the form.
            return {
                type: FormBuilderComponentTypes.MultipleChoice,
                label: 'Admissions Categories',
                description: 'Does the applicant qualify under any of these admissions categories? Please tick only those that apply.',
                key: 'admissionCategories',
                options: [],
                enableValidation: false
            };
        case FormBuilderComponentTypes.UPN:
            return {
                type: FormBuilderComponentTypes.UPN,
                label: 'UPN',
                description: 'Please enter the Unique Pupil Number (UPN).',
                key: 'upn',
                enableValidation: false
            };
        case FormBuilderComponentTypes.PreviousSchoolName:
            return {
                type: FormBuilderComponentTypes.PreviousSchoolName,
                label: 'Previous School Name',
                description: 'Please enter the name of @StudentForename\'s current or most recently attended school.',
                key: 'previousSchoolName',
                enableValidation: false
            };
        case FormBuilderComponentTypes.PreviousSchoolEmail:
            return {
                type: FormBuilderComponentTypes.PreviousSchoolEmail,
                label: 'Previous School Email',
                description: 'Please enter the email address of @StudentForename\'s current or most recently attended school.',
                key: 'previousSchoolEmail',
                enableValidation: false
            };
        case FormBuilderComponentTypes.EmployeeSelect:
            return {
                type: FormBuilderComponentTypes.EmployeeSelect,
                label: 'Employee Select',
                description: 'Please select an employee.',
                enableValidation: true
            };
        case FormBuilderComponentTypes.Calculation:
            return {
                type: FormBuilderComponentTypes.Calculation,
                label: 'Calculation',
                description: '',
                operands: []
            };
        case FormBuilderComponentTypes.StudentPhoto:
            return {
                type: FormBuilderComponentTypes.StudentPhoto,
                label: 'Student Photo',
                description: '',
                alignment: 'left',
            };
        default:
            break;
    }
};